import React, { useState, forwardRef } from "react";
import { RadioGroupField, Radio } from "@aws-amplify/ui-react";

const RegionSelector = (props) => {
  const [selectedRegion, setSelectedRegion] = useState("UK");
  const handleRegionChange = (newRegion) => {
    if (selectedRegion !== newRegion) {
      setSelectedRegion(newRegion);
      props.selectedRegion.current = newRegion;
    }
  };

  return (
    <RadioGroupField
      className="region"
      name="region"
      label="Select Region: "
      direction="row"
      value={selectedRegion}
      onChange={(e) => {
        handleRegionChange(e.target.value);
      }}
    >
      <Radio value="UK">UK</Radio>
      <Radio value="US">US</Radio>
    </RadioGroupField>
  );
};

export default React.memo(RegionSelector);
